import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import PengeluaranOperasionalService from '../../services/pengeluaranOperasionalServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk(
  'pengeluaranOperasional/list',
  async ({ page, perPage, sort, orderBy, search, cabangId, expenseType, month, year }, thunkAPI) => {
    try {
      const response = await PengeluaranOperasionalService.getList(
        page,
        perPage,
        sort,
        orderBy,
        search,
        cabangId,
        expenseType,
        month,
        year
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createData = createAsyncThunk('pengeluaranOperasional/create', async (data, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.create(data);
    thunkAPI.dispatch(setMessage({ message: 'Pengeluaran berhasil ditambahkan', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('pengeluaranOperasional/read', async (id, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.read(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('pengeluaranOperasional/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.update(id, data);
    thunkAPI.dispatch(setMessage({ message: 'Pengeluaran berhasil diubah', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('pengeluaranOperasional/delete', async (id, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.del(id);
    thunkAPI.dispatch(setMessage({ message: 'Pengeluaran berhasil dihapus', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const uploadReceipt = createAsyncThunk('pengeluaranOperasional/uploadReceipt', async ({ id, data }, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.uploadReceipt(id, data);
    thunkAPI.dispatch(setMessage({ message: 'Nota berhasil diupload', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteReceipt = createAsyncThunk('pengeluaranOperasional/deleteReceipt', async ({ id, fileId }, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.deleteReceipt(id, fileId);
    thunkAPI.dispatch(setMessage({ message: 'Nota berhasil dihapus', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const checkBalance = createAsyncThunk('pengeluaranOperasional/checkBalance', async ({ cabangId, nominal }, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.checkBalance(cabangId, nominal);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getHistory = createAsyncThunk(
  'pengeluaranOperasional/getHistory',
  async ({ cabangId, page, perPage, month, year }, thunkAPI) => {
    try {
      const response = await PengeluaranOperasionalService.getHistory(cabangId, page, perPage, month, year);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getListArchive = createAsyncThunk(
  'pengeluaranOperasional/getListArchive',
  async ({ page, perPage, sort, orderBy, search, cabangId, expenseType, startDate, endDate, createdBy }, thunkAPI) => {
    try {
      const response = await PengeluaranOperasionalService.getListArchive(
        page,
        perPage,
        sort,
        orderBy,
        search,
        cabangId,
        expenseType,
        startDate,
        endDate,
        createdBy
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const changeStatus = createAsyncThunk('pengeluaranOperasional/changeStatus', async ({ id, status }, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.changeStatus(id, status);
    thunkAPI.dispatch(setMessage({ message: 'Status berhasil diubah', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const permanentDelete = createAsyncThunk('pengeluaranOperasional/permanentDelete', async (id, thunkAPI) => {
  try {
    const response = await PengeluaranOperasionalService.permanentDelete(id);
    thunkAPI.dispatch(setMessage({ message: 'Data berhasil dihapus permanen', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = {
  isLoading: false,
  list: [],
  data: null,
  balanceWarning: null,
  history: [],
  archiveList: [],
  error: null
};

const pengeluaranOperasionalSlice = createSlice({
  name: 'pengeluaranOperasional',
  initialState,
  reducers: {
    clearData: (state) => {
      state.data = null;
    },
    clearBalanceWarning: (state) => {
      state.balanceWarning = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getList.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(createData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.balanceWarning = action.payload?.balance_warning;
      })
      .addCase(createData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(readData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(readData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(uploadReceipt.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadReceipt.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(uploadReceipt.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteReceipt.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteReceipt.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(deleteReceipt.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(checkBalance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(checkBalance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.balanceWarning = action.payload;
      })
      .addCase(checkBalance.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getHistory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.history = action.payload;
      })
      .addCase(getHistory.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.archiveList = action.payload;
      })
      .addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(permanentDelete.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(permanentDelete.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(permanentDelete.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { clearData, clearBalanceWarning } = pengeluaranOperasionalSlice.actions;
const { reducer } = pengeluaranOperasionalSlice;
export default reducer;

